const isValidRedirectPath = redirectPath => Boolean(redirectPath.match(/^\/.+(\/.+)*\/?$/));

const getRedirectPathFromParams = queryParams => {
  const paramName = 'redirect_url';
  const regex = new RegExp(`[\\?&]${paramName}=([^&#]*)`);
  const results = regex.exec(queryParams);
  const redirectPath = results && results[1];

  if (redirectPath) {
    return decodeURIComponent(redirectPath.replace(/\+/g, ' '));
  }

  return null;
};

export const getRedirectPath = queryParams => {
  const redirectPath = getRedirectPathFromParams(queryParams);

  if (redirectPath && isValidRedirectPath(redirectPath)) {
    return decodeURIComponent(redirectPath.replace(/\+/g, ' '));
  }

  return '/';
};

const referredFrom = (service, queryParams) => {
  switch (service) {
    case 'checkout':
      return getRedirectPath(queryParams).startsWith('/checkout');
    case 'favourites':
      return getRedirectPath(queryParams).startsWith('/u/favourites');
    default:
      return false;
  }
};

export const isInCheckoutFlow = queryParams => referredFrom('checkout', queryParams);
export const isInFavouritesFlow = queryParams => referredFrom('favourites', queryParams);
